<template>
  <div v-if="pressMention" class="press-mention" :class="{ 'press-mention--reversed': pressMention.image_alignment === 'Right' }">
    <component :is="pressMention.link ? 'a' : 'div'" :href="pressMention.link || undefined" class="press-mention__container">
      <div v-if="pressMention.image" class="press-mention__image">
        <img :src="pressMention.image" :alt="pressMention.text" width="113" height="40" loading="lazy" />
      </div>
      <p v-if="pressMention.text" class="press-mention__text">{{ pressMention.text }}</p>
    </component>
  </div>
</template>

<script setup>
  defineProps({
    pressMention: {
      type: Object,
      default: null,
    },
  });
</script>
